import { useFetch, useNuxtApp } from "nuxt/app";
import { hash } from "ohash";
export function createUseOpenFetch(client, lazy = false) {
  return (url, options = {}) => {
    const nuxtApp = useNuxtApp();
    const fetch = typeof client === "string" ? nuxtApp[`$${client}`] : client;
    const key = hash({
      url: typeof url === "string" ? url : url(),
      method: options.method,
      path: options.path,
      query: options.query,
      body: options.body
    });
    const opts = { $fetch: fetch, key, ...options };
    if (opts.header) {
      opts.headers = opts.header;
      delete opts.header;
    }
    return useFetch(url, lazy ? { ...opts, lazy } : { ...opts });
  };
}
